var TournamentPoolRules = React.createClass({
    mixins: [React.addons.PureRenderMixin],
    render: function() {
        return (
            <div>
    <div className="tournament-pool">
        <h1>MOBC BLOCKLES TOURNAMENT</h1>
        <br />
        {/*<h3>
            Please see the{' '}
            <a href="#p/TournamentPoolBrackets" className="white">
                <b>brackets</b>
            </a>
        </h3>
        <br />*/}
        <h2>GENERAL RULES:</h2>
        <h4>The tournament will divide into two phases: the initial 1v1 matchups followed by 2v2 matchups. Players will be matched based on their performance in the 1v1 phase, with the top players pairing with the bottom players in the same order.
        </h4>
        <br />
        <h3>Registration and Match Structure</h3>
        <ol>
            <li>
                <strong>Eligibility: </strong> All participants must “register” by March 01. To register, users must join the <a href="https://discord.gg/5hCwpec6zY"> MOBC Discord Server</a>, and react to the Registration Message with their schedule availability confirmation.
            </li>
            <li>
                <strong>Phase 1 - 1v1 Matchups:</strong> Will take place from March 4th to March 10th. (Every contestant will play against each other contestant in a round-robin format to ensure all players compete equally across the field. Rankings will be determined by wins, with points scored as a tiebreaker).
            </li>
            <li>
                <strong>Phase 2 - 2v2 Matchups: </strong>Scheduled from March 11th to March 17th. (Remember that teams are formed by pairing the highest-ranking player from the 1v1 phase with the lowest-ranking, the second-highest with the second-lowest, and so on).
            </li>
        </ol>
    </div>
    <div>
        <h2>GAMEPLAY RULES</h2>
        <ol>
            <li>
                <strong>Items: </strong>There are no restrictions on the use of items during matches.
            </li>
            <li>
                <strong>Connectivity Issues:</strong> If a player loses connection or cannot attend a scheduled match:
                <ol>
                    <li className="bullet">
                        The affected match can proceed as a 1v2, with the solo player receiving a 10-second advantage at the start if your teammate doesn’t return in the first 5 minutes.
                    </li>
                    <li className="bullet">
                        Rescheduling is allowed if the opposing team agrees. It's encouraged to communicate any issues well in advance.
                    </li>
                    <li className="bullet">
                        If you get disconnected more than once, you’re automatically disqualified, and your teammate can proceed as established above.
                    </li>
                </ol>
            </li>
        </ol>
    </div>
    <div>
        <h2>TOURNAMENT PROGRESSION</h2>
        <ol>
            <li>
               <strong> 1v1 Phase: </strong> Players will compete in a best-of-five format. The winner is determined by who wins three out of five games.
            </li>
            <li>
               <strong>2v2 Phase: </strong> Teams formed based on the 1v1 phase results will compete in a knockout format until a champion team emerges.
            </li>
        </ol>
    </div>
    <div>
        <h2>PRIZES:</h2>
        <ol>
            <li>
                <strong>First Place Team: $200 (divided equally with $100 for each team member).</strong>
            </li>
        </ol>
    </div>
    <div>
        <h2>CONDUCT AND FAIR PLAY:</h2>
        <ol>
            <li>
                Players are expected to maintain a high standard of integrity and fair play. Cheating, exploiting bugs, or unsportsmanlike conduct will result in immediate disqualification.
            </li>
            <li>
                All participants must be ready to play at their scheduled match times. Delays or no-shows without prior notice and agreement for rescheduling may lead to forfeiture.
            </li>
        </ol>
    </div>
    <div>
        <h2>DISPUTES AND RESOLUTIONS</h2>
        <ol>
            <li>
                Any disputes will be resolved by the tournament organizers. Decisions are final and binding.
            </li>
            <li>
                Players are encouraged to record their matches to assist in resolving any disputes.
            </li>
            <li>
                REPTILEXXX has generously volunteered to act as a referee for the tournament. The referee will oversee matches to ensure fair play, resolve disputes, and enforce the rules as outlined above.
            </li>
        </ol>
    </div>
    <div>
        <h2>AMENDMENTS</h2>
        <ol>
            <li>
                Tournament organizer reserves the right to make changes to the rules at any time if needed. Participants will be notified of any significant changes.
            </li>
        </ol>
    </div>
</div>
        )
    },
})